import { DialogActions, DialogContent, Stack, Typography } from '@mui/material';
import { useAppTFunction } from '@retail/app/i18n';
import { MgItemSearchAutocomplete } from '@retail/products/containers';
import { MgSupplierItemSearchResultDTO } from '@retail/products/types';
import { ContainedButton, TextButton } from '@shared/components';
import { SelectedReplacementItem } from './SelectedReplacementItem';

interface Props {
  selectedItem?: MgSupplierItemSearchResultDTO;
  selectItem: (item: MgSupplierItemSearchResultDTO) => void;
  clearSelectedItem: () => void;
  onClose: () => void;
  onContinue: () => void;
}

export function SelectReplacementItem({
  selectedItem,
  selectItem,
  clearSelectedItem,
  onClose,
  onContinue,
}: Props) {
  const t = useAppTFunction();

  return (
    <>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Typography variant="body2">
          {t('myAssortment.actions.searchForReplacementItem')}
        </Typography>

        <MgItemSearchAutocomplete onItemClick={selectItem} enableFocusHotkey={false} autoFocus />

        {selectedItem && (
          <SelectedReplacementItem item={selectedItem} clearSelectedItem={clearSelectedItem} />
        )}
      </DialogContent>

      <DialogActions>
        <TextButton onClick={onClose}>{t('products.cancel')}</TextButton>

        <ContainedButton disabled={!selectedItem} size="small" onClick={onContinue}>
          {t('myAssortment.actions.continueWithItem')}
        </ContainedButton>
      </DialogActions>
    </>
  );
}
